import { normalizeProductId, PRODUCT_BY_ID, type ProductId } from '@/config/products';
import { resolveProductFromHostname } from '@/config/billingCatalog';

const STORAGE_KEY = 'cotaskr:entry-product';

export function getStoredEntryProductId(): ProductId | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    return normalizeProductId(raw);
  } catch {
    return null;
  }
}

export function setStoredEntryProductId(productId: ProductId): void {
  try {
    localStorage.setItem(STORAGE_KEY, productId);
  } catch {
    /* ignore */
  }
}

export function clearStoredEntryProductId(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

/** Pure read — no localStorage writes (safe during render). */
export function readEntryProductId(
  search: string,
  hostname = typeof window !== 'undefined' ? window.location.hostname : '',
): ProductId {
  const fromHost = resolveProductFromHostname(hostname);
  if (fromHost) return fromHost;

  const param = new URLSearchParams(search).get('product');
  const fromQuery = param ? normalizeProductId(param) : null;
  if (fromQuery && PRODUCT_BY_ID[fromQuery]) return fromQuery;

  return getStoredEntryProductId() ?? 'pm';
}

/** Persist entry product from URL/host (call once on auth page mount). */
export function persistEntryProductFromUrl(
  search: string,
  hostname = window.location.hostname,
): ProductId {
  const id = readEntryProductId(search, hostname);
  setStoredEntryProductId(id);
  return id;
}

/** @deprecated Use readEntryProductId + persistEntryProductFromUrl */
export function resolveEntryProductId(search: string, hostname = window.location.hostname): ProductId {
  return persistEntryProductFromUrl(search, hostname);
}
